import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ProjectSheet } from '../ProjectSheet'
import { useProjectEditSingleSheetData } from '../../hooks/projectEditData'
import { useProjectSelectOptions } from '../../hooks/projectSelectOptions'
import { useProjectEditBasicInformationTableDef } from './basic-information-table-def/edit'
import { isProjectDeletable } from '../../../../../domain/entity/ProjectEntity'
import { loginToProjectByUserAction } from '../../../../../store/project'
import { APPLICATION_FUNCTION_EXTERNAL_ID } from '../../..'

type Props = {
  code?: string
}

// プロジェクト登録画面（テナントメニュー）。作成＋更新＋削除＋ログイン。DBへ直接保存する。
export const ProjectEditPage = ({ code }: Props) => {
  const dispatch = useDispatch()
  const { deleteProject, ...sheet } = useProjectEditSingleSheetData(code || '')
  const { entity, isCreating } = sheet
  const options = useProjectSelectOptions()
  const tableDef = useProjectEditBasicInformationTableDef(isCreating, options)
  const canDelete = isProjectDeletable(entity?.status)
  // 既存プロジェクトで、自分がアサインされている場合のみログイン可。
  const canLogin = !isCreating && !!entity?.assigned
  const onLogin = useCallback(() => {
    if (entity) dispatch(loginToProjectByUserAction(entity.uuid))
  }, [dispatch, entity])

  return (
    <ProjectSheet
      functionExternalId={APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_REGISTRATION}
      {...sheet}
      tableDef={tableDef}
      // 作成中（未登録）は削除・ログインボタンを出さない。
      onDelete={isCreating ? undefined : deleteProject}
      deleteDisabled={!canDelete}
      onLogin={isCreating ? undefined : onLogin}
      loginDisabled={!canLogin}
    />
  )
}
